import styled from 'styled-components/macro';

export const FloorInformationWrapper = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    position: relative;
`;
